import React, { Fragment, useEffect, useRef, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import MessageChatItemMini from "./MessageChatItemMini";

const MiniChat = ({
  auth: { user, isAuthenticated },
  messages,
  chatMessages,
  message,
  deleteMessage,
  setShowGifs,
  sendMessage,
  setShowMiniChat,
  setShowMiniModChat,
  handleInputChange,
  maxLength,
  filterText,
  setFilterText,
  profile,
  TimeOut,
  setShowReportUser,
  setReportedUser,
  setShowBanUser,
  setBannedUser,
  moderators,
  moderate,
  deleteModerator,
  timeoutDeleteMessage,
  banDeleteMessage,
  Ban,
  viewerCount,
  setMessage,
  gifMode,
}) => {
  const inputRef = useRef(null);

  const [mention, setMention] = useState(false);

  const [xFalse, setXFalse] = useState(false);

  const [str, setStr] = useState(" ");

  function checkWord(word) {
    if (word) {
      word.split(" ").map((x) => {
        if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
          setMention(true);
        } else {
          setMention(false);
        }
      });
    }
  }

  function addMention(e, message) {
    let messageArray = message.split(" ");
    messageArray.pop();
    messageArray.push(e.currentTarget.attributes.value.value);
    setMessage(messageArray.join(" ").toString());
    setMention(false);
  }

  useEffect(() => {
    checkWord(message);
  }, [message]);

  useEffect(() => {
    if (message) {
      message.split(" ").map((x) => {
        if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
          setStr(x);
        }
      });
    }
  }, [message]);

  return (
    <Fragment>
      <div className="mini-live-stream-side-container">
        {user.channelid === "roland" && isAuthenticated && (
          <div className="container-name">
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniModChat(true);
                setShowMiniChat(false);
              }}
            >
              <i className="fas fa-users-cog red mr-5"></i>Mods
            </p>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniChat(true);
                setShowMiniModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
          </div>
        )}
        {user && user.channelid !== "roland" && (
          <div className="container-name">
            {moderators &&
              moderators.length > 0 &&
              moderators.map((mod) => {
                if (mod.channelid === user.channelid) {
                  return (
                    <p
                      className="container-title cursor red"
                      onClick={() => {
                        setShowMiniModChat(true);
                        setShowMiniChat(false);
                      }}
                    >
                      <i className="fas fa-users-cog red mr-5"></i>Mods
                    </p>
                  );
                }
              })}
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniChat(true);
                setShowMiniModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
          </div>
        )}
        {user.channelid === "roland" && (
          <div className="chat-search">
            <input
              type="text"
              className="gif-input"
              name="text"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              placeholder="Search for messages..."
            />
            <i className="fas fa-search magnifying red fa-lg cursor"></i>
          </div>
        )}
        <ScrollToBottom className="all-content-mini">
          {messages &&
            messages.length > 0 &&
            messages.map((message, index) => (
              <MessageChatItemMini
                key={index}
                user={user}
                message={message}
                messages={messages}
                deleteMessage={deleteMessage}
                isAuthenticated={isAuthenticated}
                profile={profile}
                TimeOut={TimeOut}
                setShowReportUser={setShowReportUser}
                setReportedUser={setReportedUser}
                setShowBanUser={setShowBanUser}
                setBannedUser={setBannedUser}
                moderators={moderators}
                moderate={moderate}
                deleteModerator={deleteModerator}
                timeoutDeleteMessage={timeoutDeleteMessage}
                banDeleteMessage={banDeleteMessage}
                Ban={Ban}
                xFalse={xFalse}
              />
            ))}
          {filterText !== "" && chatMessages && chatMessages.length > 0
            ? chatMessages
                .filter((message) => {
                  return (
                    message.firstname.toLowerCase().match(filterText) ||
                    message.text.toLowerCase().match(filterText) ||
                    message.firstname.match(filterText) ||
                    message.text.match(filterText)
                  );
                })
                .map((message, index) => {
                  return (
                    <MessageChatItemMini
                      key={index}
                      user={user}
                      message={message}
                      chatMessages={chatMessages}
                      deleteMessage={deleteMessage}
                      isAuthenticated={isAuthenticated}
                      profile={profile}
                      TimeOut={TimeOut}
                      setShowReportUser={setShowReportUser}
                      setReportedUser={setReportedUser}
                      setShowBanUser={setShowBanUser}
                      setBannedUser={setBannedUser}
                      moderators={moderators}
                      moderate={moderate}
                      deleteModerator={deleteModerator}
                      timeoutDeleteMessage={timeoutDeleteMessage}
                      banDeleteMessage={banDeleteMessage}
                      Ban={Ban}
                      xFalse={xFalse}
                    />
                  );
                })
            : chatMessages &&
              chatMessages.map((message, index) => (
                <MessageChatItemMini
                  key={index}
                  user={user}
                  message={message}
                  chatMessages={chatMessages}
                  deleteMessage={deleteMessage}
                  isAuthenticated={isAuthenticated}
                  profile={profile}
                  TimeOut={TimeOut}
                  setShowReportUser={setShowReportUser}
                  setReportedUser={setReportedUser}
                  setShowBanUser={setShowBanUser}
                  setBannedUser={setBannedUser}
                  moderators={moderators}
                  moderate={moderate}
                  deleteModerator={deleteModerator}
                  timeoutDeleteMessage={timeoutDeleteMessage}
                  banDeleteMessage={banDeleteMessage}
                  Ban={Ban}
                  xFalse={xFalse}
                />
              ))}
        </ScrollToBottom>
        {user && user.role !== "employer" && (
          <div>
            {isAuthenticated &&
              !user.banned &&
              !user.timed_out &&
              user.founding_supporter_type !== "Good" && (
                <div className="chat-message-container-mini">
                  {mention && (
                    <div className="room-users-container">
                      <div className="room-users-mini">
                        <ul>
                          {viewerCount &&
                            viewerCount
                              .filter((y) => {
                                return y.channelid.match(str.substring(1));
                              })
                              .map((c) => {
                                if (c.channelid !== "") {
                                  return (
                                    <li
                                      onClick={(e) => {
                                        addMention(e, message);
                                        inputRef.current.focus();
                                      }}
                                      className={`room-user-item ${
                                        c.role === "innovator"
                                          ? "green"
                                          : c && c.role === "mentor"
                                          ? "red"
                                          : c && c.role === "employer"
                                          ? "blue"
                                          : ""
                                      } bold`}
                                      value={`@${c.channelid}`}
                                    >
                                      @{c.channelid}
                                    </li>
                                  );
                                }
                              })}
                        </ul>
                      </div>
                    </div>
                  )}
                  <div className="comment-reply-input-hidden">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                        user && user.avatar
                      }`}
                      className="chat-avi-user"
                      alt="avatar"
                    />
                    {gifMode && user.channelid === "roland" && (
                      <input
                        className="comment-reply-input"
                        type="text"
                        value={message}
                        ref={inputRef}
                        onChange={handleInputChange}
                        maxLength={100}
                        onKeyPress={(e) => {
                          if (
                            message.length <= maxLength &&
                            e.key === "Enter"
                          ) {
                            sendMessage(e);
                          }
                        }}
                        placeholder="Type your message here..."
                      />
                    )}
                    {!gifMode && (
                      <input
                        className="comment-reply-input"
                        type="text"
                        value={message}
                        ref={inputRef}
                        onChange={handleInputChange}
                        maxLength={100}
                        onKeyPress={(e) => {
                          if (
                            message.length <= maxLength &&
                            e.key === "Enter"
                          ) {
                            sendMessage(e);
                          }
                        }}
                        placeholder="Type your message here..."
                      />
                    )}

                    {isAuthenticated &&
                      user.founding_supporter_type !== "Good" &&
                      user.founding_supporter_type !== "" && (
                        <div
                          className={`gif-button-container ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                          onClick={() => setShowGifs(true)}
                        >
                          <p className="gif-button">GIF</p>
                        </div>
                      )}
                    <p className="white character-counter-comment">
                      {message.length}/{maxLength} characters
                    </p>
                  </div>
                </div>
              )}
            {isAuthenticated && user.banned && (
              <div className="chat-message-container-mini">
                <div className="comment-reply-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <div className="user-banned-alt red">
                    <i className="fa-solid fa-ban mr-5 fa-lg red"></i>Banned
                  </div>
                </div>
              </div>
            )}
            {isAuthenticated && user.timed_out && (
              <div className="chat-message-container-mini">
                <div className="comment-reply-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <div className="user-banned-alt red">
                    <i className="fa-solid fa-clock mr-5 fa-lg red"></i>
                    Timed Out
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

MiniChat.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
});

export default connect(mapStateToProps, {})(MiniChat);
